export const defaultToolbarExportSlotProps = {
  printOptions: { disableToolbarButton: true },
  csvOptions: { disableToolbarButton: false },
  excelOptions: { disableToolbarButton: false },
} as const;
